<template>
  <el-dialog top="5vh"
             title=""
             :visible.sync="dialogFormVisible"
             :close-on-click-modal="false"
             :append-to-body="true"
             @open="open()"
             @close="emitClose()"
             width="1200px">

    <el-table :data="tableData"
              :header-cell-style="{
          textAlign: 'center',
          color: '#909399',
          fontFamily: 'PingFang SC',
          fontSize: '14px',
          fontWeight: '400',
          backgroundColor: '#F2F6FC',
        }"
              :cell-style="{ fontSize: '13px' }"
              @selection-change="handleSelectionChange"
              border>
      <el-table-column type="selection"
                       width="50"
                       align="center">
      </el-table-column>
      <el-table-column label="学员姓名"
                       width="100"
                       align="center"
                       fixed="left"
                       show-overflow-tooltip>
        <template slot-scope="scope">
          <el-link type="primary"
                   :underline="false">{{ scope.row.realname }}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="报名时间"
                       align="center"
                       width="120">
        <template slot-scope="scope">
          {{
                    scope.row.apply_time
                      ? $moment(scope.row.apply_time).format("YYYY-MM-DD")
                      : ""
                  }}
        </template>
      </el-table-column>

      <el-table-column label="课程状态"
                       align="center"
                       width="80">
        <template slot-scope="scope">
          <el-tag size="mini"
                  v-if="scope.row.student_sync_status == 1"
                  type="warning">待对接</el-tag>
          <el-tag size="mini"
                  v-if="scope.row.student_sync_status == 2"
                  type="warning">待分配</el-tag>
          <el-tag size="mini"
                  v-if="scope.row.student_sync_status == 3">匹配中</el-tag>
          <el-tag size="mini"
                  v-if="scope.row.student_sync_status == 4">上课中</el-tag>
          <el-tag size="mini"
                  v-if="scope.row.student_sync_status == 5"
                  type="info">已终止</el-tag>
          <el-tag size="mini"
                  v-if="scope.row.student_sync_status == 6"
                  type="danger">已结束</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="所在班级"
                       width="200"
                       align="left"
                       show-overflow-tooltip>
        <template slot-scope="scope">
          <el-dropdown trigger="click"
                       v-if="!scope.row.grade_names">
            <el-link type="primary"
                     :underline="false">{{ formateMember(scope.row.grade_names) }}
            </el-link>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">
                <div class="dropdown-item">
                  新建班级
                </div>
              </el-dropdown-item>
              <el-dropdown-item command="b">
                <div class="dropdown-item">
                  加入班级
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <div v-else>
            <el-link type="primary"
                     :underline="false">
              {{ formateGrade_names(scope.row.grade_names) }}
            </el-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="课程进度"
                       width="120"
                       align="center"
                       show-overflow-tooltip>
        <template slot-scope="scope">
          <el-progress :text-inside="true"
                       :stroke-width="20"
                       :percentage="
                      scope.row.course_progress
                        ? parseFloat(
                            (Number(scope.row.course_progress) * 100).toFixed(2)
                          )
                        : 0
                    "></el-progress>
        </template>
      </el-table-column>
      <el-table-column label="报考信息"
                       width="400"
                       align="left"
                       show-overflow-tooltip>
        <template slot-scope="scope">
          <span>
            {{
                      scope.row.apply_year ? `${scope.row.apply_year}年` : ""
                    }}
          </span>
          /
          <span class="pointer">{{ scope.row.apply_college_name }} </span>/ ({{ scope.row.apply_major_code }}){{
                    scope.row.apply_major_name
                  }}
          /
          {{ scope.row.apply_academy_name }}
          /
          <span v-if="scope.row.apply_direction_name">
            {{
                      scope.row.apply_direction_code
                        ? `(${scope.row.apply_direction_code})${scope.row.apply_direction_name}`
                        : scope.row.apply_direction_name
                    }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="辅导科目"
                       width="160"
                       align="left"
                       show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-for="(item, index) in scope.row.subjects || []"
                :key="index">
            ({{ item.subject_code }}){{ item.subject_name }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="辅导科目"
                       width="160"
                       align="left"
                       show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-for="(item, index) in scope.row.subjects || []"
                :key="index">
            ({{ item.subject_code }}){{ item.subject_name }}
          </span>
        </template>
      </el-table-column>

      <!-- <el-table-column width="100"
                       align="center"
                       show-overflow-tooltip>
        <template slot="header">
          <el-popover ref="popover">
            <span class="el-dropdown-link"
                  slot="reference">
              报名课时<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <div class="popover-item">
              小时
            </div>
            <div class="popover-item">
              课时
            </div>
          </el-popover>
        </template>
        <template slot-scope="scope">
          <div v-if="unitConversion == 1">
            {{ scope.row.service_hours }}小时
          </div>
          <div v-if="unitConversion == 2">
            {{
                      (
                        scope.row.service_hours /
                        scope.row.company.lesson_hour_hour_rate
                      ).toFixed(2)
                    }}课时
          </div>
        </template>
      </el-table-column> -->

      <el-table-column label="复习基础"
                       width="240"
                       align="left"
                       prop="coach_need"
                       show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="参考书目"
                       width="240"
                       align="left"
                       prop="refer_book"
                       show-overflow-tooltip>
      </el-table-column>

      <el-table-column prop="remark"
                       align="left"
                       label="服务备注"
                       width="300"
                       show-overflow-tooltip>
      </el-table-column>

      <!-- <el-table-column label="跟进标签"
                       align="left"
                       width="200">
        <template slot-scope="scope">
          <el-select v-model="scope.row.follow_up_tag_ids"
                     multiple
                     filterable
                     allow-create
                     collapse-tags
                     default-first-option
                     placeholder="请选择跟进标签">
            <el-option v-for="item in followUpTag"
                       :key="item.id"
                       :label="item.tag"
                       :value="item.id">
            </el-option>
          </el-select>
        </template>
      </el-table-column> -->
      <el-table-column label="跟进备注"
                       align="left"
                       width="260"
                       prop=""
                       show-overflow-tooltip>
        <template slot-scope="scope">
          <el-input v-model="scope.row.follow_up_remark"
                    placeholder="请输入跟进备注"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="最近上课时间"
                       align="center"
                       width="150">
        <template slot-scope="scope">
          {{
                    scope.row.last_lesson_time 
                      ? $moment(scope.row.last_lesson_time ).format(
                          "YYYY-MM-DD HH:mm"
                        )
                      : ""
                  }}
        </template>
      </el-table-column>
      <el-table-column label="最近记录时间"
                       width="200"
                       align="center">
        <template slot-scope="scope">
          {{
                    scope.row.last_manage_record_create_time
                      ? $moment(
                          scope.row.last_manage_record_create_time
                        ).format("YYYY-MM-DD HH:mm")
                      : ""
                  }}
        </template>
      </el-table-column>
      <el-table-column label="最近记录内容"
                       width="200"
                       align="center">
        <template slot-scope="scope">
          {{
                    scope.row.last_manage_record_content_text
                      ?
                          scope.row.last_manage_record_content_text
                      : ""
                  }}
        </template>
      </el-table-column>
      <el-table-column label="机构简称"
                       align="center"
                       width="130"
                       show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.company ? scope.row.company.name : "" }}
        </template>
      </el-table-column>
      <el-table-column label="对接老师"
                       align="center"
                       width="130"
                       show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.docking_man_nickname || "无" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="学管老师"
                       align="center"
                       width="130">
        <template slot-scope="scope">
          {{
                    scope.row.learn_manager
                      ? scope.row.learn_manager.nickname
                      : ""
                  }}
        </template>
      </el-table-column>

      <el-table-column prop="name"
                       label="教务老师"
                       width="140"
                       align="center">
        <template slot-scope="scope">
          <span>
            {{
                      scope.row.watcher
                        ? scope.row.watcher.map((item) => item.alias).join(",")
                        : "-"
                    }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="创建老师"
                       width="140"
                       align="center"
                       prop="manage_creator.nickname">
      </el-table-column>

    </el-table>
    <div style="margin-top: 16px">

      <div class="block">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>

    <div slot="footer"
         class="dialog-footer">
      <el-button type="primary"
                 @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { studentlist } from '../../../request/api'
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      },
      tableData: [],
      pageTotal: 0,
      chooseList: [],
    }
  },
  mounted() {},
  watch: {
    isVisible(val) {
      console.log('val444', val)
      this.dialogFormVisible = val
    },
  },
  methods: {
    handleSelectionChange(val) {
      this.chooseList = val
    },
    open() {
      this.fetchList()
    },
    formateMember(val) {
      if (val) {
        let val_arr = val.split(',')
        if (val_arr.length > 3) {
          return val.split(',').slice(0, 3).join('，') + '等'
        } else {
          return val.split(',').slice(0, 3).join('，')
        }
      } else {
        return '分配班级'
      }
    },
    formateGrade_names(val) {
      let arr = val ? val.split(',') : []
      if (arr.length > 1) {
        return `${arr.slice(0, 1).join('，')}等${arr.length}个班级`
      } else {
        return arr.join(',')
      }
    },
    fetchList(isReset = false) {
      const params = Object.assign({}, this.query)
      studentlist(params).then((response) => {
        let res = response.data
        this.pageTotal = res.data.count
        this.tableData = []
        this.tableData =
          res.data.count > 0
            ? res.data.list.map((v) => {
                return {
                  ...v,
                  follow_up_tag_ids:
                    v.follow_up_tag_ids && v.follow_up_tag_ids.length
                      ? v.follow_up_tag_ids.split(',').map((t) => Number(t))
                      : [],

                  manage_tags_arr:
                    v.manage_tags && v.manage_tags.length
                      ? v.manage_tags.split(',').map((t) => {
                          return Number(t)
                        })
                      : [],
                }
              })
            : []
      })
      // courseList(params).then((response) => {
      //   let res = response.data
      //   this.result = res.data.list || []
      //   this.pageTotal = res.data.count
      // })
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.fetchList()
    },
    handleCurrentChange(val) {
      this.query.pageIndex = val
      this.fetchList()
    },
    emitClose() {
      this.$emit('close')
    },
    submit() {
      this.$emit('chooseList', this.chooseList)
      this.$emit('close')
      this.chooseList = []
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-footer {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>